import { datadogRum } from '@datadog/browser-rum';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Team allocation mapping based on frontend views from CODEOWNERS
const TEAM_ALLOCATIONS = {
  // Due Diligence Team (github-squad-due-dilligence)
  '/audits': 'github-squad-due-dilligence',
  '/capa': 'github-squad-due-dilligence',
  '/questionnaires': 'github-squad-due-dilligence',
  '/risk-analysis': 'github-squad-due-dilligence',
  '/slcp': 'github-squad-due-dilligence',
  '/claims': 'github-squad-due-dilligence',
  '/standards': 'github-squad-due-dilligence',
  '/company-documents': 'github-squad-due-dilligence',

  // Tracing Team (github-squad-tracing)
  '/cascade-map': 'github-squad-tracing',
  '/cascade-tracing': 'github-squad-tracing',
  '/supply-chains': 'github-squad-tracing',
  '/fiber': 'github-squad-tracing',
  '/entity-screening': 'github-squad-tracing',

  // Integrations/Analytics Team (github-squad-integrations-automations-analytics)
  '/dashboard': 'github-squad-integrations-automations-analytics',
  '/reports': 'github-squad-integrations-automations-analytics',
  '/badges': 'github-squad-integrations-automations-analytics',
  '/products': 'github-squad-integrations-automations-analytics',
  '/my-styles': 'github-squad-integrations-automations-analytics',
  '/companies': 'github-squad-integrations-automations-analytics',
  '/company-profiles': 'github-squad-integrations-automations-analytics',

  // General Team (github-squad-x)
  '/management': 'github-squad-x',
  '/api-keys': 'github-squad-x',
  '/profile': 'github-squad-x',
  '/users': 'github-squad-x',
  '/constants-mapping': 'github-squad-x',
};

const DataDogRouteWrapper = ({ children }) => {
  const location = useLocation();
  const firstPathSegment = location.pathname.split('/')[1] || 'home';

  useEffect(() => {
    const teamForPath =
      TEAM_ALLOCATIONS[`/${firstPathSegment}`] || 'github-squad-x';

    datadogRum.setGlobalContextProperty(
      'test_feature',
      `${firstPathSegment}_feature`,
    );
    datadogRum.setGlobalContextProperty('team', teamForPath);
    datadogRum.setGlobalContextProperty('view_path', location.pathname);
  }, [location.pathname, firstPathSegment]);

  return <>{children}</>;
};

export default DataDogRouteWrapper;
